import React from 'react';
import { Card, CssBaseline } from '@mui/material';
import styled from 'styled-components';
import { Navbar } from '../Navbar/Navbar';
import { Footer } from '../Footer';
import { AboutUs } from './section/AboutPage';
import SEO from '../../components/SEO';

const StyledCard = styled.div`
  background-color: #f7f7f7;
  padding: 0px;
 box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
`;

const TopMargin = styled.div`
  margin-top: 100px;
`;

function About() {
  return (
    <>
      <SEO
        title="About WatchNod | Server & API Monitoring Platform"
        description="Learn about WatchNod, a reliable server and API monitoring platform offering real-time alerts, uptime tracking, and scalable solutions to keep your systems running."
        url="/about"
        type="website"
      />
      <Navbar />
      <TopMargin />
      <CssBaseline />
      <StyledCard>
        <Card>
          <AboutUs />
        </Card>
      </StyledCard>
      <div style={{ position: 'relative', bottom: 0, width: '100%' }}>
        <Footer />
      </div>
    </>
  );
}

export default About;
